export enum ProductType {
    Part = "PART",
    Accessory = "ACCESSORY",
    Assistance = "ASSISTANCE"
}